import React, { useContext } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css'; // Ensure to import React Tabs styles
import ProductDetail from './productDetail';
import UserDetail from './UserDetail';
import myContext from '../../../Context/myContext';


const AdminDashboard = () => {
    
    const user=JSON.parse(localStorage.getItem('users'));
    const context=useContext(myContext);
    const {getAllProduct}=context;

    return (
        <div className="container-fluid bg-light min-vh-100">
            {/* Top Section */}
            <div className="row mb-5 px-3 px-md-5">
                <div className="col-12">
                    <div className="bg-light border border-primary rounded-lg p-4 shadow-sm">
                        <h1 className="text-center text-primary">Admin Dashboard</h1>
                    </div>
                </div>
            </div>

            {/* Mid Section */}
            <div className="row mb-5 px-3 px-md-5">
                <div className="col-12">
                    <div className="bg-light border border-primary rounded-lg p-4 shadow-sm text-center">
                        <img 
                            src="https://cdn-icons-png.flaticon.com/128/2202/2202112.png" 
                            alt="Profile" 
                            className="img-fluid mb-3"
                            style={{ maxWidth: '150px' }} 
                        />
                        <h2 className="text-primary"><span className="font-weight-bold">Name:  </span>{user.name}</h2>
                        <h3 className="text-primary"><span className="font-weight-bold">Email: </span> 
                        {user.email}</h3>
                        <h4 className="text-primary"><span className="font-weight-bold">Role: </span> 
                        {user.role}</h4>
                    </div>
                </div>
            </div>

            {/* Bottom Section */}
            <div className="row px-3 px-md-5">
                <div className="col-12">
                    <Tabs>
                        <TabList className="nav nav-tabs mb-4">
                            {/* Total Products Tab */}
                            <Tab className="nav-item">
                                <button className="nav-link active" type="button">Total Products</button>
                            </Tab>
                           
                            {/* Total Users Tab */}
                            <Tab className="nav-item">
                                <button className="nav-link" type="button">Add Product</button>
                            </Tab>
                        </TabList>

                        {/* Tab Panels */}
                        <TabPanel className="p-4 bg-light border border-primary rounded-lg shadow-sm">
                            <div className="d-flex justify-content-center flex-wrap">
                                <div className="border bg-light hover:bg-gray-100 border-primary px-4 py-3 rounded-xl m-2">
                                    <div className="text-primary w-12 h-12 mb-3 inline-block">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={50}
                                            height={50}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-shopping-basket"
                                        >
                                            <path d="m5 11 4-7" />
                                            <path d="m19 11-4-7" />
                                            <path d="M2 11h20" />
                                            <path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8c.9 0 1.8-.7 2-1.6l1.7-7.4" />
                                            <path d="m9 11 1 9" />
                                            <path d="M4.5 15.5h15" />
                                            <path d="m15 11-1 9" />
                                        </svg>
                                    </div>
                                    <h2 className="title-font font-medium text-3xl text-primary">
  {getAllProduct?.length || 0}
</h2>

                                    <p className="text-primary font-weight-bold">Total Products</p>
                                </div>

                                
                                <div className="border bg-light hover:bg-gray-100 border-primary px-4 py-3 rounded-xl m-2">
                                    <div className="text-primary w-12 h-12 mb-3 inline-block">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={50}
                                            height={50}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-users"
                                        >
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx={9} cy={7} r={4} />
                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                        </svg>
                                    </div>
<h2 className="title-font font-medium text-3xl text-primary">
  {getAllProduct?.length || 0}
</h2>
                                    <p className="text-primary font-weight-bold">Total Users</p>
                                </div>
                            </div>
                        </TabPanel>

                        <TabPanel className="p-4 bg-light border border-primary rounded-lg shadow-sm">
                          <ProductDetail/>
                        </TabPanel>

                       

                        <TabPanel className="p-4 bg-light border border-primary rounded-lg shadow-sm">
                            <UserDetail/>
                        </TabPanel>
                    </Tabs>
                </div>
            </div>
        </div>
    );
}

export default AdminDashboard;
